import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { ToastContainer } from "react-toastify";
import {
  getLeads,
  editLeads,
  deleteLeads,
  addLeads,
  getAddons,
  getAddonData,
  importLeads,
  getUsers,
  getStudios,
} from "../../services/api/api";
import Loader from "../loader/Loader";
import Booking from "../booking/Booking";
import { Tooltip } from "react-tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { FileUpload } from "primereact/fileupload";
import { Tag } from "primereact/tag";
import Swal from "sweetalert2";
import { Sidebar } from "primereact/sidebar";
import { Divider } from "primereact/divider";
import {
  fetchData,
  showToast,
  formateName,
  paymentStatus,
  exportCustomCSV,
  exportCustomXLSX,
  strTODateFormate,
  dateFormate,
  trimObjectValues,
  getSerialNo,
} from "../utils/Function/Helper";
import {
  ExportButton,
  SampleButton,
  NewButton,
  DeleteButton,
  ActionButton,
  SearchBar,
  NormalButton,
} from "../utils/Atoms/Atoms";
import csvFileUrl from "../../assets/sample_files/sample_lead_data.csv";
import xlsxFileUrl from "../../assets/sample_files/sample_lead_data.xlsx";

const LeadList = ({ status_url }) => {
  const user = useSelector((state) => state.user);
  console.log(user.userDetails);

  const [statusData, setStatusData] = useState({});
  let emptyLead = {
    superadmin_id: user?.userDetails?.ID || null,
    teamlead_id: user?.userDetails?.TeamLeadID || null,
    teamlead_name: "",
    user_id: user?.userDetails?.UserID || null,
    user_name: "",
    id: null,
    team_id: 1,
    lead_name: "",
    mobile_number: "",
    email_address: "",
    lead_location: "",
    enquiry_date: "",
    shoot_location: "",
    package_interested: "",
    photoshoot_type_id: null,
    lead_source_id: null,
    lead_status_id: statusData.id,
    priority_id: null,
    studio_id: null,
    photographer_id: null,
    telecaller_id: null,
    booking_id: "",
    last_contact_date: "",
    next_followup_date: "",
    followup_notes: "",
    total_budget: "",
    amount_paid: "",
    shoot_date: "",
    slot_time: "",
    duration: "",
    decline_reason: "",
    local_selected_date: "",
    payment_status: "",
    trigger_value: "",
  };
  const shootLocationOption = [
    { value: "Studio", label: "Studio" },
    { value: "Home", label: "Home" },
  ];
  const [data, setData] = useState(emptyLead);
  const [datas, setDatas] = useState([]);
  const [users, setUsers] = useState([]);
  const [studios, setStudios] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedDatas, setSelectedDatas] = useState(null);
  const [popup, setPopup] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingapi, setLoadingapi] = useState(true);
  const [addonsData, setAddonsData] = useState([]);
  const [buffering, setBuffering] = useState(false);
  const dt = useRef(null);
  const fileUploadRef = useRef(null);

  // loader
  const loader = () => {
    setBuffering(true);
    setTimeout(() => {
      setBuffering(false);
    }, 500); // 0.5 second delay
  };

  // get status data
  useEffect(() => {
    getAddonData({
      superadmin_id: user?.userDetails?.ID || null,
      source_url: status_url,
    }).then((response) => {
      if (response.status) {
        setStatusData(response.data[0]);
      }
    });
    setPopup(null);
  }, [user, status_url]);

  // get status leads data
  useEffect(() => {
    getLeads({
      ...emptyLead,
      lead_status: status_url,
    })
      .then((response) => {
        if (response.status) {
          let data = response.data.map((item) => {
            const { lead_data, ...rest } = item; // Destructure lead_data and the rest of the object
            const combinedObject = { ...lead_data, ...rest };
            return combinedObject;
          });
          setDatas(data);
        } else {
          setDatas([]);
          console.log("warning", "No Data to Show !");
        }
      })
      .catch((error) => {
        setDatas([]);
        console.log("warning", error);
      });
    loader();
  }, [user, status_url, loadingapi]);

  // get addons data
  useEffect(() => {
    getAddons({ superadmin_id: user?.userDetails?.ID, source: "All" }).then(
      (response) => {
        if (response.status) {
          setAddonsData(response.data);
        }
      }
    );
    fetchData(() => getUsers(emptyLead), setUsers);
    fetchData(() => getStudios(emptyLead), setStudios);
  }, [user]);

  //setting payment status in form data
  useEffect(() => {
    setData((prevFormData) => ({
      ...prevFormData,
      ["payment_status"]: paymentStatus(data.total_budget, data.amount_paid),
    }));
  }, [data.total_budget, data.amount_paid]);

  // reseting the page
  const resetPage = () => {
    setPopup(null);
    setData(emptyLead);
    setLoadingapi((prev) => !prev);
  };

  // open dialog boxes
  const openDialogBox = (data, id) => {
    setData({ ...data });
    setPopup(id);
    if (id === 1) setSubmitted(false);
  };

  // hide dialog boxes
  const hideDialog = () => {
    setSubmitted(false);
    setData(emptyLead);
    setPopup(null);
  };

  // get team leads
  const getTeamLeads = () => {
    return users.reduce((acc, curr) => {
      if (!acc.some((item) => item.teamlead_id === curr.teamlead_id)) {
        acc.push({
          teamlead_id: curr.teamlead_id,
          teamlead_name: curr.teamlead_name,
        });
      }
      return acc;
    }, []);
  };

  // get user under teamlead
  const getTeamUsers = () => {
    if (!data || !data.teamlead_id || !Array.isArray(users)) {
      return [];
    }

    return users
      .filter((item) => item.teamlead_id === Number(data.teamlead_id))
      .map((item) => ({
        user_id: item.id,
        user_name: item.user_name,
      }));
  };

  // validate date
  const isValidDate = (date) => {
    const parsedDate = new Date(date);
    return parsedDate instanceof Date && !isNaN(parsedDate.getTime());
  };

  // validate email and number
  const validateField = (fieldName, value) => {
    const validators = {
      email_address: (val) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) ? "" : "Invalid email address",
      mobile_number: (val) =>
        /^[6-9]\d{9}$/.test(val) ? "" : "Invalid mobile number",
    };

    return validators[fieldName] ? validators[fieldName](value) : ""; // Return validation message or empty if valid
  };

  // update inputs
  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    const newItem = { ...data };

    if (user?.userDetails?.TeamLeadID || null) {
      newItem[`teamlead_name`] = getTeamLeads()[0].teamlead_name;
    }
    if (user?.userDetails?.UserID || null) {
      newItem[`user_name`] = getTeamUsers()[0].user_name;
    }

    switch (name) {
      case "shoot_date":
      case "last_contact_date":
      case "next_followup_date":
        newItem[name] =
          val instanceof Date && !isNaN(val.getTime())
            ? strTODateFormate(val)
            : "";
        break;

      case "mobile_number":
        newItem[name] = val.replace(/\D/g, "").slice(0, 10);
        break;

      case "package_interested":
        newItem[name] = val;
        newItem["total_budget"] = val;
        break;

      case "lead_status_id":
      case "photographer_id":
      case "telecaller_id":
      case "photoshoot_type_id":
      case "lead_source_id":
      case "priority_id":
        newItem[name] = val;
        newItem[`${name.replace(/_id$/, "")}`] =
          addonsData.find((item) => item.id === Number(val))?.source_value ||
          "";
        break;

      case "total_budget":
      case "amount_paid":
        newItem[name] = val;
        break;

      case "teamlead":
      case "user":
        let options = name === "teamlead" ? getTeamLeads() : getTeamUsers();
        newItem[`${name}_id`] = val;
        newItem[`${name}_name`] = options.filter((item) => {
          if (item[`${name}_id`] === val) {
            return item;
          }
        })[0][`${name}_name`];
        break;

      case "lead_name":
        newItem[name] = formateName(
          val.replace(/[^a-zA-Z0-9 ]/g, "").trimStart()
        );
        break;

      default:
        newItem[name] = val.trimStart();
    }
    setData(newItem);
  };

  // reset state after operation
  const resetStates = () => {
    setSubmitted(false);
    setLoading(false);
    resetPage();
  };

  // Helper: Handle booking slot scenario
  const handleBookingSlot = () => {
    setPopup(null);
    setSubmitted(false);
    Swal.fire({
      title: `Click OK to proceed to booking slot selection`,
      text: "Otherwise data will lose",
      icon: "info",
      confirmButtonColor: "#dc3545",
      confirmButtonText: "Okay",
      showCancelButton: true,
      customClass: {
        title: "swal2-title-custom",
        htmlContainer: "swal2-text-custom",
        confirmButton: "swal2-confirm-button-custom",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setPopup(8);
      } else {
        Swal.fire(
          "Action Cancelled",
          "You can continue editing the form.",
          "info"
        );
      }
    });
  };

  // Helper: Handle decline reason popup
  const handleDeclineReasonPopup = () => {
    resetStates();
    openDialogBox(data, 6);
  };

  // handle Api Response
  const handleApiResponse = (response) => {
    response.status
      ? showToast("success", response.message)
      : showToast("warning", response.message);
    resetStates();
  };

  // validate required fields
  const hasMissingFields = (fields) => fields.some((field) => !data[field]);

  // validate email and mobile number
  const isInvalidContact = () =>
    validateField("mobile_number", data.mobile_number) ||
    (data.email_address && validateField("email_address", data.email_address));

  // add and edit Item
  const addItem = async (status) => {
    setSubmitted(true);
    // update trigger value
    if (data.lead_status_id) {
      data.trigger_value = addonsData.find(
        (item) => item.id === data.lead_status_id
      )?.trigger_status;
    }

    // validation for contact fields
    if (isInvalidContact()) return;

    // validation based on status
    const validations = {
      add: [
        "lead_name",
        "mobile_number",
        "lead_location",
        "photoshoot_type_id",
        "shoot_date",
        "lead_status_id",
        "shoot_location",
        "lead_source_id",
        "priority_id",
        "package_interested",
      ],
      status: ["last_contact_date", "lead_status_id", "telecaller_id"],
      statusonly: ["lead_status_id", "photographer_id", "total_budget"],
      decline: ["decline_reason"],
    };

    // validation check
    if (
      (validations[status] && hasMissingFields(validations[status])) ||
      (status === "status" &&
        data.trigger_value === 0 &&
        !data.next_followup_date)
    ) {
      return;
    }

    // Handle specific cases based on status and trigger_value
    if (data.trigger_value === 1 && status !== "statusonly") {
      handleBookingSlot();
      return;
    }

    if (data.trigger_value === 3 && status !== "decline") {
      handleDeclineReasonPopup();
      return;
    }

    // Perform API call
    setLoading(true);
    let _data = trimObjectValues(data);
    const response = data.id ? await editLeads(_data) : await addLeads(_data);
    handleApiResponse(response);
  };

  // required keys for import
  const requiredKeys = {
    enquiry_date: "enquiry_date",
    lead_name: "lead_name",
    mobile_number: "mobile_number",
    email_address: "email_address",
    lead_location: "lead_location",
    photoshoot_type_id: "photoshoot_type",
    shoot_location: "shoot_location",
    package_interested: "package_interested",
    lead_source_id: "lead_source",
    priority_id: "priority",
    shoot_date: "preference_date",
    followup_notes: "followup_notes",
    teamlead: "teamlead",
    user: "user",
  };

  // filtered data
  const filteredData = (data) => {
    return data.map((row) => {
      const filteredRow = {};
      for (const [key, headerName] of Object.entries(requiredKeys)) {
        if (
          row["lead_name"] === undefined ||
          row["mobile_number"] === undefined ||
          row["lead_location"] === undefined
        ) {
          return null;
        } else if (headerName === "mobile_number") {
          filteredRow[key] = String(row[headerName])
            .replace(/\D/g, "")
            .slice(-10);
        } else if (
          headerName === "teamlead" ||
          headerName === "user" ||
          row[headerName] !== undefined
        ) {
          if (
            headerName === "photoshoot_type" ||
            headerName === "shoot_location" ||
            headerName === "priority" ||
            headerName === "lead_source"
          ) {
            let data = addonsData.find(
              (item) =>
                item.source_value.toLowerCase() ===
                row[headerName].trim().toLowerCase()
            );
            filteredRow[key] = data ? data.id : "";
          } else if (headerName === "teamlead") {
            if (user?.userDetails?.TeamLeadID || null) {
              filteredRow[`teamlead_id`] = getTeamLeads()[0]?.teamlead_id;
              filteredRow[`teamlead_name`] = getTeamLeads()[0]?.teamlead_name;
            } else {
              if (row[headerName] === undefined) {
                filteredRow["teamlead_id"] = "";
                filteredRow["teamlead_name"] = "";
              } else {
                let data = getTeamLeads().find(
                  (item) =>
                    item.teamlead_name.toLowerCase() ===
                    row[headerName].trim().toLowerCase()
                );
                filteredRow[`teamlead_id`] = data ? data.teamlead_id : "";
                filteredRow[`teamlead_name`] = data ? data.teamlead_name : "";
              }
            }
          } else if (headerName === "user") {
            if (user?.userDetails?.UserID || null) {
              filteredRow[`user_id`] = user?.userDetails?.UserID;
              filteredRow[`user_name`] = user?.userDetails?.UserName;
            } else {
              if (row[headerName] === undefined) {
                filteredRow["user_id"] = "";
                filteredRow["user_name"] = "";
              } else {
                let data = getTeamUsers().find(
                  (item) =>
                    item.user_name.toLowerCase() ===
                    row[headerName].trim().toLowerCase()
                );
                filteredRow["user_id"] = data ? data.id : "";
                filteredRow["user_name"] = data ? data.user_name : "";
              }
            }
          } else if (
            headerName === "preference_date" ||
            headerName === "enquiry_date"
          ) {
            filteredRow[key] = dateFormate(row[headerName]);
          } else {
            filteredRow[key] = row[headerName].toString();
          }
        } else {
          filteredRow[key] = "";
        }
      }
      filteredRow["lead_status_id"] = statusData.id;
      filteredRow["superadmin_id"] = user?.userDetails?.ID;
      return filteredRow;
    });
  };

  // csv to array
  const csvToArray = (event) => {
    return new Promise((resolve, reject) => {
      try {
        const file = event.files[0]; // Get the selected file
        const reader = new FileReader();
        reader.onload = (e) => {
          const csvData = e.target.result;
          const workbook = XLSX.read(csvData, { type: "string" });
          const sheetName = workbook.SheetNames[0];
          const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          const validData = filteredData(jsonData).filter(
            (row) => row !== null
          ); // Filter out null rows (skipped rows)
          resolve(validData);
          fileUploadRef.current.clear();
        };
        reader.readAsText(file); // Read CSV as text
      } catch (error) {
        reject(error);
      }
    });
  };
  const handleCsvImportFile = (event) => {
    csvToArray(event)
      .then((data) => {
        importLeads(data)
          .then((response) => {
            console.log(response);
            response.status
              ? showToast("success", response.message)
              : showToast("warning", response.message);
            setLoadingapi((prev) => !prev);
          })
          .catch((error) => {
            showToast("warning", error.message);
          });
      })
      .catch((error) => {
        showToast("Error during file import : ", error.message);
      });
  };

  // xlsx to array
  const xlsxToArray = (event) => {
    return new Promise((resolve, reject) => {
      try {
        const file = event.files[0]; // Get the selected file
        const reader = new FileReader();

        reader.onload = (e) => {
          // Parse XLSX file
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          const validData = filteredData(jsonData).filter(
            (row) => row !== null
          ); // Filter out null rows (skipped rows)
          resolve(validData);
          fileUploadRef.current.clear();
        };
        reader.readAsArrayBuffer(file); // Read XLSX as binary
      } catch (error) {
        reject(error);
      }
    });
  };
  const handleXlsxImportFile = (event) => {
    xlsxToArray(event)
      .then((data) => {
        importLeads(data)
          .then((response) => {
            response.status
              ? showToast("success", response.message)
              : showToast("warning", response.message);
            setLoadingapi((prev) => !prev);
          })
          .catch((error) => {
            showToast("warning", error.message);
          });
      })
      .catch((error) => {
        showToast("Error during file import : ", error.message);
      });
  };

  // save and cancel button
  const dataDialogFooter = (status) => {
    return (
      <React.Fragment>
        <NormalButton
          label="Cancel"
          icon="pi-times"
          outlined={true}
          onClick={hideDialog}
        />
        {status !== "view" && (
          <NormalButton
            label="Save"
            icon="pi-check"
            disabled={loading}
            onClick={() => addItem(status)}
          />
        )}
      </React.Fragment>
    );
  };

  // export csv file
  const exportData = (type) => {
    let exportData = dt.current.props.value;
    let modifiedData = [];
    exportData.forEach((row, index) => {
      modifiedData.push({
        "s.no": index + 1,
        ...row,
      });
    });
    const headers = [
      "s.no",
      "enquiry_date",
      "lead_name",
      "mobile_number",
      "email_address",
      "lead_location",
      "shoot_location",
      "photoshoot_type",
      "package_interested",
      "last_contact_date",
      "next_followup_date",
      "telecaller",
      "followup_notes",
      "booking_id",
      "studio_name",
      "shoot_date",
      "start_time",
      "end_time",
      "duration",
      "photographer",
      "total_budget",
      "amount_paid",
      "payment_status",
      "lead_status",
      "lead_source",
      "priority",
      "decline_reason",
    ];
    if (type === "csv") {
      exportCustomCSV(headers, modifiedData, status_url);
    } else if (type === "xlsx") {
      exportCustomXLSX(headers, modifiedData, status_url);
    }
  };

  // add and delete button
  const rightToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2">
        {statusData?.position === "1" && (
          <NewButton onClick={() => openDialogBox(emptyLead, 1)} />
        )}
        {user?.userDetails?.UserRole === "Super Admin" && (
          <DeleteButton
            onClick={() => setPopup(5)}
            disabled={!selectedDatas || !selectedDatas.length}
          />
        )}
      </div>
    );
  };

  // export button
  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2">
        <ExportButton
          label={".csv"}
          datas={datas}
          onClick={() => exportData("csv")}
        />
        <ExportButton
          label={".xlsx"}
          datas={datas}
          onClick={() => exportData("xlsx")}
        />
        {statusData?.position === "1" && (
          <>
            <FileUpload
              ref={fileUploadRef}
              mode="basic"
              name="csv"
              accept=".csv"
              customUpload
              auto
              uploadHandler={handleCsvImportFile}
              chooseOptions={{
                label: ".csv",
                icon: "pi pi-download",
              }}
              aria-label="Import CSV file"
              className="custom-file-upload"
              data-tooltip-id={"Import"}
              data-tooltip-content={"Import"}
              data-tooltip-offset={10}
            />
            <Tooltip id={"Import"} className="tooltip" />
            <FileUpload
              ref={fileUploadRef}
              mode="basic"
              name="xlsx"
              accept=".xlsx"
              customUpload
              auto
              uploadHandler={handleXlsxImportFile}
              chooseOptions={{
                label: ".xlsx",
                icon: "pi pi-download",
              }}
              aria-label="Import Excel file"
              className="custom-file-upload"
              data-tooltip-id={"Import2"}
              data-tooltip-content={"Import"}
              data-tooltip-offset={10}
            />
            <Tooltip id={"Import2"} className="tooltip" />
            <SampleButton
              label={".csv"}
              fileUrl={csvFileUrl}
              fileName={"sample_lead"}
              type={"csv"}
            />
            <SampleButton
              label={".xlsx"}
              fileUrl={xlsxFileUrl}
              fileName={"sample_lead"}
              type={"xlsx"}
            />
          </>
        )}
      </div>
    );
  };

  // table header
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <h3 className="m-0">{statusData.source_value} Leads</h3>
      <SearchBar
        position={"left"}
        onInput={(e) => setGlobalFilter(e.target.value)}
      />
    </div>
  );

  // table action button
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <div className="flex">
          <ActionButton
            icon={"pi-eye"}
            onClick={() => {
              setData({ ...rowData });
              setPopup(7);
            }}
            id={"viewtooltip"}
            toolText={"View"}
          />
          {statusData.trigger_status === "0" && (
            <>
              <ActionButton
                icon={"pi-pen-to-square"}
                onClick={() => {
                  setData({ ...rowData });
                  setPopup(2);
                }}
                id={"statustooltip"}
                toolText={"Status Change"}
              />
              {statusData.position === "1" && (
                <ActionButton
                  icon={"pi-pencil"}
                  onClick={() => {
                    setData({ ...rowData });
                    setPopup(1);
                  }}
                  id={"edittooltop"}
                  toolText={"Edit"}
                />
              )}
            </>
          )}

          {statusData.trigger_status === "1" && (
            <>
              <ActionButton
                icon={"pi-sync"}
                onClick={() => {
                  setData({ ...rowData });
                  setPopup(8);
                }}
                id={"rescheduletooltop"}
                toolText={"Reschedule"}
              />
              <ActionButton
                icon={"pi-pen-to-square"}
                onClick={() => {
                  setData({ ...rowData });
                  setPopup(3);
                }}
                id={"statusotooltop"}
                toolText={"Status Change"}
              />
            </>
          )}
          {user?.userDetails?.UserRole === "Super Admin" && (
            <ActionButton
              icon={"pi-trash"}
              onClick={() => {
                setData({ ...rowData });
                setPopup(4);
              }}
              id={"deletetooltop"}
              toolText={"Delete"}
            />
          )}
        </div>
      </React.Fragment>
    );
  };

  // delete one item
  const deleteData = async () => {
    setLoading(true);
    const response = await deleteLeads(data);
    if (response.status) {
      showToast("success", response.message);
      resetPage();
    } else {
      showToast("warning", response?.message || response);
    }
    setLoading(false);
  };

  // delete many item
  const deleteSelectedDatas = () => {
    setLoading(true);
    const deletePromises = selectedDatas.map(async (item) => {
      const response = await deleteLeads(item);
      if (!response.status) {
        showToast("warning", response?.message || response);
      }
    });
    Promise.all(deletePromises).then(() => {
      showToast("success", "Leads Deleted");
      setSelectedDatas(null);
      resetPage();
    });
    setLoading(false);
  };

  // delete footer buttons
  const deleteDialogFooter = (callTo) => {
    return (
      <>
        <React.Fragment>
          <NormalButton
            label="No"
            icon="pi-times"
            outlined={true}
            onClick={hideDialog}
          />
          <NormalButton
            label="Yes"
            icon="pi-check"
            disabled={loading}
            onClick={callTo}
          />
        </React.Fragment>
      </>
    );
  };

  // get addon options
  const selectOption = (addon) => {
    let data = addonsData.filter((item) => item.source === addon);
    if (addon === "lead-status") {
      data = data
        .filter((item) => item.position >= statusData.position)
        .filter(
          (item) =>
            item.trigger_status <= 1 + +statusData.trigger_status ||
            item.trigger_status === 3
        )
        .map((item) => ({ value: item.id, label: item.source_value }));
    } else {
      data = data.map((item) => ({ value: item.id, label: item.source_value }));
    }
    return data;
  };

  // Tag
  const setTag = (rowData) => {
    const tag = addonsData.filter((item) => item.id === rowData.priority_id)[0];
    return tag ? (
      <Tag
        value={tag.source_value}
        style={{ background: tag.color, color: tag.text }}
      />
    ) : (
      ""
    );
  };

  // get teamlead name
  const getTLName = (rowData) => {
    if (rowData.teamlead_id) {
      return (
        getTeamLeads().filter((item) => {
          if (item.teamlead_id === rowData.teamlead_id) {
            return item;
          }
        })[0]?.teamlead_name ?? rowData.teamlead_name
      );
    }
  };

  // ge user name
  const getUserName = (rowData) => {
    if (rowData.user_id) {
      return (
        users.filter((item) => {
          if (item.id === rowData.user_id) {
            return item;
          }
        })[0]?.user_name ?? rowData.user_name
      );
    }
  };

  // get studio name
  const getStudioName = (rowData) => {
    if (rowData.studio_id) {
      return studios.filter((item) => {
        if (item.id === rowData.studio_id) {
          return item;
        }
      })[0]?.studio_name;
    }
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <>
      <ToastContainer />
      {buffering ? (
        <Loader />
      ) : (
        <>
          {popup === 8 ? (
            <Booking
              formData={data}
              setFormData={setData}
              setPopup={setPopup}
              setLoadingapi={setLoadingapi}
            />
          ) : (
            <>
              <div className="card">
                <Toolbar
                  className="mb-4"
                  start={leftToolbarTemplate}
                  end={rightToolbarTemplate}
                ></Toolbar>

                {/* table */}
                <DataTable
                  ref={dt}
                  value={datas}
                  paginator
                  rows={10}
                  className="datatable"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  globalFilter={globalFilter}
                  header={header}
                  selection={
                    user?.userDetails?.UserRole === "Super Admin"
                      ? selectedDatas
                      : []
                  }
                  onSelectionChange={(e) => setSelectedDatas(e.value)}
                  selectionMode={
                    user?.userDetails?.UserRole === "Super Admin"
                      ? "checkbox"
                      : "none"
                  }
                  emptyMessage={`No Leads Available`}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} datas"
                >
                  {user?.userDetails?.UserRole === "Super Admin" && (
                    <Column
                      selectionMode="multiple"
                      exportable={false}
                      style={{ width: "30px" }}
                    />
                  )}
                  <Column
                    header="S.No"
                    body={getSerialNo}
                    style={{ width: "30px" }}
                  />
                  {!(user?.userDetails?.TeamLeadID || null) && (
                    <Column
                      field="teamlead_id"
                      body={getTLName}
                      sortable
                      header="Team Lead"
                    />
                  )}
                  {!(user?.userDetails?.UserID || null) && (
                    <Column
                      field="user_id"
                      body={getUserName}
                      sortable
                      header="Assigned to"
                    />
                  )}
                  <Column field="lead_name" sortable header="Lead Name" />
                  <Column
                    field="mobile_number"
                    sortable
                    header="Mobile Number"
                  />
                  <Column
                    field="photoshoot_type"
                    sortable
                    header="Photoshoot Type"
                  />

                  {[0, 1].includes(Number(statusData.trigger_status)) ? (
                    <Column
                      field="shoot_date"
                      sortable
                      header={
                        {
                          0: "Preference Date",
                          1: "Shoot Date",
                        }[Number(statusData.trigger_status)]
                      }
                    />
                  ) : null}

                  {Number(statusData.trigger_status) === 0 &&
                    Number(statusData.position) > 1 && (
                      <Column
                        field="next_followup_date"
                        sortable
                        header="Next Followup"
                      />
                    )}

                  {Number(statusData.trigger_status) === 0 && (
                    <Column
                      field="followup_notes"
                      sortable
                      header="Follow Up Notes"
                    />
                  )}

                  {Number(statusData.trigger_status) === 1 && (
                    <Column field="start_time" sortable header="Slot Time" />
                  )}

                  {Number(statusData.trigger_status) <= 1 && (
                    <Column
                      field="priority"
                      body={setTag}
                      sortable
                      header="Priority"
                    />
                  )}

                  {Number(statusData.trigger_status) === 3 && (
                    <Column
                      field="decline_reason"
                      sortable
                      header="Decline Reason"
                    />
                  )}

                  <Column
                    header="Action"
                    body={actionBodyTemplate}
                    exportable={false}
                    style={{ width: "50px" }}
                  />
                </DataTable>
              </div>

              {/* 1. add and edit data dialog */}
              <Sidebar
                visible={popup === 1}
                position="right"
                header={<h4 className="mt-3 mb-0">Lead Details</h4>}
                onHide={hideDialog}
                style={{ width: window.innerWidth < 768 ? "40rem" : "50rem" }}
                aria-label="Lead Details"
                closeOnEscape={false}
                dismissable={false}
              >
                <Divider />
                <div className="row">
                  {!user?.userDetails?.TeamLeadID && (
                    <div className="field mb-3 col-md-6">
                      <div>
                        <label
                          htmlFor="photoshoot_type_id"
                          className="font-bold mb-1"
                        >
                          Team Lead *
                        </label>
                      </div>
                      <Dropdown
                        id="teamlead"
                        value={data.teamlead_id}
                        options={getTeamLeads()}
                        onChange={(e) => onInputChange(e, "teamlead")}
                        placeholder="Select a User"
                        optionLabel="teamlead_name"
                        optionValue="teamlead_id"
                        disabled={user?.userDetails?.TeamLeadID}
                        required
                        style={{ width: "100%" }}
                        className={classNames({
                          "p-invalid": submitted && !data.teamlead_id,
                        })}
                      />
                      <div>
                        {submitted && !data.teamlead_id && (
                          <small className="p-error">
                            Please Select Team Lead
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  {!user?.userDetails?.UserID && (
                    <div className="field mb-3 col-md-6">
                      <div>
                        <label
                          htmlFor="photoshoot_type_id"
                          className="font-bold mb-1"
                        >
                          Assigned To *
                        </label>
                      </div>
                      <Dropdown
                        id="user"
                        value={data.user_id}
                        options={getTeamUsers()}
                        onChange={(e) => onInputChange(e, "user")}
                        placeholder="Select a User"
                        optionValue="user_id"
                        optionLabel="user_name"
                        disabled={user?.userDetails?.UserID}
                        required
                        style={{ width: "100%" }}
                        className={classNames({
                          "p-invalid": submitted && !data.user_id,
                        })}
                      />
                      <div>
                        {submitted && !data.user_id && (
                          <small className="p-error">Please Select User</small>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label htmlFor="lead_name" className="font-bold mb-1">
                        Lead Name *
                      </label>
                    </div>
                    <InputText
                      id="lead_name"
                      value={data.lead_name}
                      onChange={(e) => onInputChange(e, "lead_name")}
                      required
                      style={{ width: "100%" }}
                      className={classNames({
                        "p-invalid": submitted && !data.lead_name,
                      })}
                    />
                    <div>
                      {submitted && !data.lead_name.trim() && (
                        <small className="p-error">
                          Lead Name is required.
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label htmlFor="mobile_number" className="font-bold mb-1">
                        Mobile Number *
                      </label>
                    </div>
                    <InputText
                      id="mobile_number"
                      value={data.mobile_number}
                      onChange={(e) => onInputChange(e, "mobile_number")}
                      required
                      style={{ width: "100%" }}
                      className={classNames({
                        "p-invalid":
                          submitted &&
                          (!data.mobile_number.trim() ||
                            validateField("mobile_number", data.mobile_number)),
                      })}
                    />
                    <div>
                      {submitted &&
                      data.mobile_number.trim() &&
                      validateField("mobile_number", data.mobile_number) ? (
                        <small className="p-error">
                          {" "}
                          {validateField("mobile_number", data.mobile_number)}
                        </small>
                      ) : submitted && !data.mobile_number.trim() ? (
                        <small className="p-error">
                          Mobile number is required
                        </small>
                      ) : null}
                    </div>
                  </div>

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label htmlFor="email_address" className="font-bold mb-1">
                        Email Address (Optional)
                      </label>
                    </div>
                    <InputText
                      id="email_address"
                      value={data.email_address}
                      onChange={(e) => onInputChange(e, "email_address")}
                      style={{ width: "100%" }}
                      className={classNames({
                        "p-invalid":
                          submitted &&
                          data.email_address &&
                          validateField("email_address", data.email_address),
                      })}
                    />
                    <div>
                      {submitted &&
                        data.email_address &&
                        validateField("email_address", data.email_address) && (
                          <small className="p-error">
                            {validateField("email_address", data.email_address)}
                          </small>
                        )}
                    </div>
                  </div>

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label htmlFor="lead_location" className="font-bold mb-1">
                        Lead Location *
                      </label>
                    </div>
                    <InputText
                      id="lead_location"
                      value={data.lead_location}
                      onChange={(e) => onInputChange(e, "lead_location")}
                      required
                      style={{ width: "100%" }}
                      className={classNames({
                        "p-invalid": submitted && !data.lead_location,
                      })}
                    />
                    <div>
                      {submitted && !data.lead_location.trim() && (
                        <small className="p-error">
                          Lead Location is required.
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label
                        htmlFor="photoshoot_type_id"
                        className="font-bold mb-1"
                      >
                        Photo Shoot Type *
                      </label>
                    </div>
                    <Dropdown
                      id="photoshoot_type_id"
                      value={data.photoshoot_type_id}
                      options={selectOption("photoshoot-type")}
                      onChange={(e) => onInputChange(e, "photoshoot_type_id")}
                      placeholder="Select a Photoshoot Type"
                      required
                      style={{ width: "100%" }}
                      className={classNames({
                        "p-invalid": submitted && !data.photoshoot_type_id,
                      })}
                    />
                    <div>
                      {submitted && !data.photoshoot_type_id && (
                        <small className="p-error">
                          Please Select photoshoot type
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label htmlFor="date" className="font-bold mb-1">
                        Preference Date *
                      </label>
                    </div>
                    <Calendar
                      id="shoot_date"
                      value={
                        isValidDate(data.shoot_date)
                          ? new Date(data.shoot_date)
                          : null
                      } // Bind valid date or empty
                      onChange={(e) => onInputChange(e, "shoot_date")} // Handle date selection
                      placeholder="Select a Date"
                      required
                      style={{ width: "100%" }}
                      className={classNames({
                        "p-invalid": submitted && !data.shoot_date,
                      })}
                      dateFormat="dd/mm/yy" // Set to the desired date format
                      showIcon // Optional: displays a calendar icon
                      minDate={new Date()}
                    />
                    <div>
                      {submitted && !data.shoot_date && (
                        <small className="p-error">Please select a date</small>
                      )}
                    </div>
                  </div>

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label
                        htmlFor="shoot_location"
                        className="font-bold mb-1"
                      >
                        Shoot Location *
                      </label>
                    </div>
                    <Dropdown
                      id="shoot_location"
                      value={data.shoot_location}
                      options={shootLocationOption}
                      onChange={(e) => onInputChange(e, "shoot_location")}
                      placeholder="Select a Shoot Location"
                      required
                      style={{ width: "100%" }}
                      className={classNames({
                        "p-invalid": submitted && !data.shoot_location,
                      })}
                    />
                    <div>
                      {submitted && !data.shoot_location && (
                        <small className="p-error">
                          Please select shoot location
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label
                        htmlFor="lead_source_id"
                        className="font-bold mb-1"
                      >
                        Lead Source *
                      </label>
                    </div>
                    <Dropdown
                      id="lead_source_id"
                      value={data.lead_source_id}
                      options={selectOption("lead-source")}
                      onChange={(e) => onInputChange(e, "lead_source_id")}
                      placeholder="Select a Lead Source"
                      required
                      style={{ width: "100%" }}
                      className={classNames({
                        "p-invalid": submitted && !data.lead_source_id,
                      })}
                    />
                    <div>
                      {submitted && !data.lead_source_id && (
                        <small className="p-error">
                          Please select lead Source
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label htmlFor="priority" className="font-bold mb-1">
                        Priority *
                      </label>
                    </div>
                    <Dropdown
                      id="priority"
                      value={data.priority_id}
                      options={selectOption("priority")}
                      onChange={(e) => onInputChange(e, "priority_id")}
                      placeholder="Select a Priority"
                      required
                      style={{ width: "100%" }}
                      className={classNames({
                        "p-invalid": submitted && !data.priority_id,
                      })}
                    />
                    <div>
                      {submitted && !data.priority_id && (
                        <small className="p-error">
                          Please select priority
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="field mb-3 col-md-6">
                    <div>
                      <label
                        htmlFor="package_interested"
                        className="font-bold mb-1"
                      >
                        Package Interested *
                      </label>
                    </div>
                    <InputNumber
                      maxLength={9}
                      id="package_interested"
                      value={data.package_interested}
                      placeholder="Please enter packgae"
                      onValueChange={(e) =>
                        onInputChange(e, "package_interested")
                      }
                      required
                      style={{ width: "100%" }}
                      locale="en-IN"
                      className={classNames({
                        "p-invalid": submitted && !data.package_interested,
                      })}
                    />
                    <div>
                      {submitted && !data.package_interested && (
                        <small className="p-error">
                          Package Intested is required.
                        </small>
                      )}
                    </div>
                  </div>
                </div>

                <div className="field mt-5">{dataDialogFooter("add")}</div>
              </Sidebar>

              {/* 2. status change dialog- this will have status and followup date */}
              <Sidebar
                visible={popup === 2}
                position="right"
                header={<h4 className="mt-3 mb-0">Followup Details</h4>}
                onHide={hideDialog}
                style={{ width: window.innerWidth < 768 ? "20rem" : "25rem" }}
                aria-label="Followup Details"
                closeOnEscape={false}
                dismissable={false}
              >
                <Divider />

                <div className="field mb-3">
                  <div>
                    <label
                      htmlFor="last_contact_date"
                      className="font-bold mb-1"
                    >
                      Last Contact Date *
                    </label>
                  </div>
                  <Calendar
                    id="last_contact_date"
                    value={
                      isValidDate(data.last_contact_date)
                        ? new Date(data.last_contact_date)
                        : null
                    } // Bind valid date or empty
                    onChange={(e) => onInputChange(e, "last_contact_date")} // Handle date selection
                    placeholder="Select a Date"
                    required
                    style={{ width: "100%" }}
                    className={classNames({
                      "p-invalid": submitted && !data.last_contact_date,
                    })}
                    dateFormat="dd/mm/yy" // Set to the desired date format
                    showIcon // Optional: displays a calendar icon
                    minDate={new Date()}
                  />
                  <div>
                    {submitted && !data.last_contact_date && (
                      <small className="p-error">
                        Please select a Last contacted date
                      </small>
                    )}
                  </div>
                </div>

                <div className="field mb-3">
                  <div>
                    <label
                      htmlFor="next_followup_date"
                      className="font-bold mb-1"
                    >
                      Next Followup Date *
                    </label>
                  </div>
                  <Calendar
                    id="next_followup_date"
                    value={
                      isValidDate(data.next_followup_date)
                        ? new Date(data.next_followup_date)
                        : null
                    } // Bind valid date or empty
                    onChange={(e) => onInputChange(e, "next_followup_date")} // Handle date selection
                    placeholder="Select a Date"
                    style={{ width: "100%" }}
                    dateFormat="dd/mm/yy" // Set to the desired date format
                    showIcon // Optional: displays a calendar icon
                    minDate={
                      data.last_contact_date && new Date(data.last_contact_date)
                    }
                  />
                  <div>
                    {submitted &&
                      data.trigger_value === 0 &&
                      !data.next_followup_date && (
                        <small className="p-error">
                          Please select a Next Follow Up Date
                        </small>
                      )}
                  </div>
                </div>

                <div className="field mb-3">
                  <div>
                    <label htmlFor="lead_status_id" className="font-bold mb-1">
                      Lead Status *
                    </label>
                  </div>
                  <Dropdown
                    id="lead_status_id"
                    value={data.lead_status_id}
                    options={selectOption("lead-status")}
                    onChange={(e) => onInputChange(e, "lead_status_id")}
                    placeholder="Select a Lead Status"
                    required
                    style={{ width: "100%" }}
                    className={classNames({
                      "p-invalid": submitted && !data.lead_status_id,
                    })}
                  />
                  <div>
                    {submitted && !data.lead_status_id && (
                      <small className="p-error">
                        Please select lead status
                      </small>
                    )}
                  </div>
                </div>

                <div className="field mb-3">
                  <div>
                    <label htmlFor="telecaller_id" className="font-bold mb-1">
                      Telecaller
                    </label>
                  </div>
                  <Dropdown
                    id="telecaller_id"
                    value={data.telecaller_id}
                    options={selectOption("telecaller")}
                    onChange={(e) => onInputChange(e, "telecaller_id")}
                    required
                    placeholder="Select a Telecaller"
                    style={{ width: "100%" }}
                  />
                  <div>
                    {submitted && !data.telecaller_id && (
                      <small className="p-error">
                        Please select a Telecaller
                      </small>
                    )}
                  </div>
                </div>

                <div className="field mb-3">
                  <div>
                    <label htmlFor="followup_notes" className="mb-1">
                      Followup Notes
                    </label>
                  </div>
                  <InputTextarea
                    id="followup_notes"
                    value={data.followup_notes}
                    onChange={(e) => onInputChange(e, "followup_notes")}
                    rows={5}
                    cols={30}
                    style={{ width: "100%" }}
                    placeholder="Enter your message here"
                  />
                </div>

                <div className="field mt-5">{dataDialogFooter("status")}</div>
              </Sidebar>

              {/* 3. only status change dialog */}
              <Sidebar
                visible={popup === 3}
                position="right"
                header={<h4 className="mt-3 mb-0">Status Details</h4>}
                onHide={hideDialog}
                style={{ width: window.innerWidth < 768 ? "20rem" : "25rem" }}
                aria-label="Status Details"
                closeOnEscape={false}
                dismissable={false}
              >
                <Divider />

                <div className="field mb-3">
                  <div>
                    <label htmlFor="lead_status_id" className="font-bold mb-1">
                      Lead Status *
                    </label>
                  </div>
                  <Dropdown
                    id="lead_status_id"
                    value={data.lead_status_id}
                    options={selectOption("lead-status")}
                    onChange={(e) => onInputChange(e, "lead_status_id")}
                    placeholder="Select a Lead Status"
                    required
                    style={{ width: "100%" }}
                    className={classNames({
                      "p-invalid": submitted && !data.lead_status_id,
                    })}
                  />
                  <div>
                    {submitted && !data.lead_status_id && (
                      <small className="p-error">
                        Please select lead status
                      </small>
                    )}
                  </div>
                </div>

                <div className="field mb-3">
                  <div>
                    <label htmlFor="total_budget" className="font-bold mb-1">
                      Total Amount
                    </label>
                  </div>
                  <InputNumber
                    id="total_budget"
                    value={data.total_budget}
                    placeholder="Please enter packgae"
                    onValueChange={(e) => onInputChange(e, "total_budget")}
                    required
                    style={{ width: "100%" }}
                    className={classNames({
                      "p-invalid": submitted && !data.total_budget,
                    })}
                  />
                  <div>
                    {submitted && !data.total_budget && (
                      <small className="p-error">
                        Please enter total amount
                      </small>
                    )}
                  </div>
                </div>

                <div className="field mb-3">
                  <div>
                    <label
                      htmlFor="amount_paid mb-3"
                      className="font-bold mb-1"
                    >
                      Amount Paid
                    </label>
                  </div>

                  <InputNumber
                    id="amount_paid"
                    value={data.amount_paid}
                    style={{ width: "100%" }}
                    placeholder="Please enter packgae"
                    onValueChange={(e) => onInputChange(e, "amount_paid")}
                  />
                </div>

                <div className="field mb-3">
                  <div>
                    <label htmlFor="photographer_id" className="font-bold mb-1">
                      Photographer
                    </label>
                  </div>
                  <Dropdown
                    id="photographer_id"
                    value={data.photographer_id}
                    options={selectOption("photographer")}
                    onChange={(e) => onInputChange(e, "photographer_id")}
                    placeholder="Select a Photographer"
                    required
                    style={{ width: "100%" }}
                    className={classNames({
                      "p-invalid": submitted && !data.photographer_id,
                    })}
                  />
                  <div>
                    {submitted && !data.photographer_id && (
                      <small className="p-error">
                        Please selcet Photographer
                      </small>
                    )}
                  </div>
                </div>
                <div className="field mt-5">
                  {dataDialogFooter("statusonly")}
                </div>
              </Sidebar>

              {/* 4. delete single data dialog */}
              <Dialog
                visible={popup === 4 ? true : false}
                style={{ width: "32rem" }}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header="Confirm"
                modal
                footer={deleteDialogFooter(deleteData)}
                onHide={() => setPopup(null)}
              >
                <div>
                  <i
                    className="pi pi-exclamation-triangle me-3"
                    style={{ fontSize: "2rem" }}
                  />
                  {data && (
                    <span>
                      Are you sure you want to delete <b>{data.lead_name}</b> ?
                    </span>
                  )}
                </div>
              </Dialog>

              {/* 5. delete many datas dialog */}
              <Dialog
                visible={popup === 5 ? true : false}
                style={{ width: "32rem" }}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header="Confirm"
                modal
                footer={deleteDialogFooter(deleteSelectedDatas)}
                onHide={() => setPopup(null)}
              >
                <div>
                  <i
                    className="pi pi-exclamation-triangle me-3"
                    style={{ fontSize: "2rem" }}
                  />
                  {data && (
                    <span>
                      Are you sure you want to delete the selected Items ?
                    </span>
                  )}
                </div>
              </Dialog>

              {/* 6. decline dialog */}
              <Sidebar
                visible={popup === 6}
                position="right"
                header={<h4 className="mt-3 mb-0">Decline Details</h4>}
                onHide={hideDialog}
                style={{ width: window.innerWidth < 768 ? "20rem" : "25rem" }}
                aria-label="Decline Details"
                closeOnEscape={false}
                dismissable={false}
              >
                <Divider />

                <div className="field mb-3">
                  <div>
                    <label htmlFor="decline_reason">Decline Reason</label>
                  </div>
                  <InputTextarea
                    id="decline_reason"
                    value={data.decline_reason}
                    onChange={(e) => onInputChange(e, "decline_reason")}
                    rows={5}
                    cols={30}
                    style={{ width: "100%" }}
                    placeholder="Enter your message here"
                    className={classNames({
                      "p-invalid": submitted && !data.decline_reason,
                    })}
                  />
                  <div>
                    {submitted && !data.decline_reason && (
                      <small className="p-error">
                        Please Enter Decline Reason
                      </small>
                    )}
                  </div>
                </div>
                <div className="field mt-5">{dataDialogFooter("decline")}</div>
              </Sidebar>

              {/* 7. Show data dialog */}
              <Sidebar
                visible={popup === 7}
                position="right"
                header={<h4 className="mt-3 mb-0">Lead Details</h4>}
                onHide={hideDialog}
                style={{ width: window.innerWidth < 768 ? "20rem" : "25rem" }}
                aria-label="Lead Details"
                closeOnEscape={false}
                dismissable={false}
              >
                <Divider />
                <div>
                  {!(user?.userDetails?.TeamLeadID || null) && (
                    <p>
                      Team Lead :{" "}
                      <b>
                        {getTLName({ teamlead_id: data?.teamlead_id }) || "N/A"}
                      </b>
                    </p>
                  )}
                  {!(user?.userDetails?.UserID || null) && (
                    <>
                      <p>
                        Assigned to :{" "}
                        <b>
                          {getUserName({ user_id: data?.user_id }) || "N/A"}
                        </b>
                      </p>
                      <hr />
                    </>
                  )}
                  <p>
                    Enquiry Date : <b>{data?.enquiry_date || "N/A"}</b>
                  </p>
                  <p>
                    Lead Name : <b>{data?.lead_name || "N/A"}</b>
                  </p>
                  <p>
                    Mobile Number : <b>{data?.mobile_number || "N/A"}</b>
                  </p>
                  <p>
                    Email Address: <b>{data?.email_address || "N/A"}</b>
                  </p>
                  <p>
                    Lead Location : <b>{data?.lead_location || "N/A"}</b>
                  </p>
                  <p>
                    Photoshoot Type: <b>{data?.photoshoot_type}</b>
                  </p>
                  <p>
                    Telecaller : <b>{data?.telecaller || "N/A"}</b>
                  </p>
                  <p>
                    Preference/ Shoot Date : <b>{data?.shoot_date || "N/A"}</b>
                  </p>
                  <p>
                    Shoot Time : <b>{data?.start_time || "N/A"}</b>
                  </p>
                  <p>
                    Shoot Duration : <b>{data?.duration || "N/A"}</b>
                  </p>
                  <p>
                    Shoot Location : <b>{data?.shoot_location || "N/A"}</b>
                  </p>
                  <p>
                    Studio Name :{" "}
                    <b>
                      {getStudioName({ studio_id: data?.studio_id }) || "N/A"}
                    </b>
                  </p>
                  <p>
                    Photographer Name : <b>{data?.photographer || "N/A"}</b>
                  </p>
                  <p>
                    Lead Source : <b>{data?.lead_source || "N/A"}</b>
                  </p>
                  <p>
                    Lead Status : <b>{data?.lead_status || "N/A"}</b>
                  </p>
                  <p>
                    Priority : <b>{data?.priority || "N/A"}</b>
                  </p>
                  <p>
                    Package Interested :{" "}
                    <b>₹ {data?.package_interested || "N/A"}</b>
                  </p>
                  <p>
                    Last Contacted Date :{" "}
                    <b>{data?.last_contact_date || "N/A"}</b>
                  </p>
                  <p>
                    Next Followup Date :{" "}
                    <b>{data?.next_followup_date || "N/A"}</b>
                  </p>
                  <p>
                    Booking ID : <b>{data?.booking_id || "N/A"}</b>
                  </p>
                  <p>
                    Total Budget : <b>₹ {data?.total_budget || "N/A"}</b>
                  </p>
                  <p>
                    Amount Paid : <b>₹ {data?.amount_paid || "N/A"}</b>
                  </p>
                  <p>
                    Payment Status : <b>{data?.payment_status || "N/A"}</b>
                  </p>
                  <p>
                    Followup Notes : <b>{data?.followup_notes || "N/A"}</b>
                  </p>
                  <p>
                    Decline Reason : <b>{data?.decline_reason || "N/A"}</b>
                  </p>
                </div>
                <div className="field mt-5">{dataDialogFooter("view")}</div>
              </Sidebar>
            </>
          )}
        </>
      )}
    </>
  );
};

export default LeadList;
